import router from './router'
import store from '@/store'
import Vue from 'vue'

router.beforeEach(async(to, from, next) => {
  const needAuth = to.meta.needAuth
  // 1. 判断本地是否有登录凭证
  if (localStorage.getItem('userInfo')) {
    if (to.path === '/login' || to.path === '/register') {
      next({ path: '/' })
    } else {
      /* let userRoles = store.getters.roles || []
      if (userRoles.length === 0) {
        // getUserRoles 内部包含从 localStorage 恢复角色的逻辑
        userRoles = await store.dispatch('getUserRoles')
      }
      // 根据当前用户的角色，动态生成该角色有权访问的 /bg 路由表
      const allRoutes = await store.dispatch('generateRoutes', userRoles)

      // 动态注入到 Vue-Router
      router.addRoutes(allRoutes)

      // 【核心】动态注入后必须 replace 重定向，确保新挂载的路由能被浏览器识别
      next({ ...to, replace: true })*/
      next()
    }
  } else {
    // 无凭证去登录页
    Vue.$cookies.remove('refresh_token')
    store.commit('USER_LOGOUT')
    if (needAuth === undefined || needAuth) {
      next('/login')
    } else {
      next()
    }
  }
})

router.afterEach((to) => {
  // 从路由配置的 meta 中获取 title
  const title = to.meta && to.meta.title
  if (title) {
    document.title = `${title}`
  } else {
    document.title = 'tnbapp'
  }
})
